import * as React from 'react';
import { Button, Col, Container, Input, Row } from 'reactstrap';
import { IdataListProps } from '../../constants';
import { EditState, ItemEditable } from '../itemEditableComponent/ItemEditableComponent';

export interface IItemEditableProps {
    editHandler: () => void;
    id: number;
    content: string;
    edit: boolean;
}

export interface IItemEditableListProps {
    addNewRecord: (newRecord: string, listIndex: number) => void;
    editHandler: (entryId: number, value: string) => void;
    saveHandler: (listIndex: number, entryId: number) => void;
    cancelHandler: () => void;
    changeHandler: (editValue: string) => void;
    selectEntry: (listIndex: number, entryId: number, selectionMethod: string) => void;
    data: IdataListProps[];
    baseDataKey: string;
    listIndex: number;
    name: string;
    editItemID: number | undefined;
    editValue: string | undefined;
}

export interface IItemEditableListState {
    addNewValue: string;
}

export default class ItemEditableList extends React.PureComponent<IItemEditableListProps, IItemEditableListState> {
    constructor(props: any) {
        super(props);
        this.state = { addNewValue: '' };
    }

    public render() {
        const ed = this.props.editItemID === undefined;

        const orderedItems = this.props.data.sort((a: IdataListProps, b: IdataListProps) => {
            if (a.content.toLocaleLowerCase() < b.content.toLocaleLowerCase()) {
                return -1;
            } else if (a.content.toLocaleLowerCase() > b.content.toLocaleLowerCase()) {
                return 1;
            }
            return 0;
        });

        return (
            <Container>
                <Row>
                    <Col>
                        <h3>{this.props.name}</h3>
                    </Col>
                </Row>
                <Row>{orderedItems.map(this.renderItemEditable)}</Row>
                <Row className="mb-5 mt-3">
                    <Col md={4}>
                        <Input
                            id={'new' + this.props.name}
                            disabled={!ed}
                            type="text"
                            value={this.state.addNewValue}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                this.setState({ addNewValue: e.currentTarget.value });
                            }}
                        />
                    </Col>
                    <Col md={4}>
                        <Button
                            disabled={!ed}
                            onClick={() => {
                                this.props.addNewRecord(this.state.addNewValue, this.props.listIndex);
                                this.setState({ addNewValue: '' });
                            }}
                        >
                            Hinzufügen
                        </Button>
                    </Col>
                </Row>
            </Container>
        );
    }

    private renderItemEditable = (item: IdataListProps) => {
        let editState: EditState;
        if (this.props.editItemID === item.id) {
            editState = EditState.This;
        } else if (this.props.editItemID === undefined) {
            editState = EditState.None;
        } else {
            editState = EditState.Other;
        }

        return (
            <ItemEditable
                key={item.id}
                editHandler={this.props.editHandler}
                saveHandler={this.props.saveHandler}
                selectEntry={this.props.selectEntry}
                cancelHandler={this.props.cancelHandler}
                changeHandler={this.props.changeHandler}
                editState={editState}
                entryId={item.id}
                listIndex={this.props.listIndex}
                content={item.content}
                editValue={this.props.editValue}
            />
        );
    };
}



// WEBPACK FOOTER //
// ./src/components/itemEditableList/ItemEditableList.tsx